import { gql } from '@apollo/client';

import { QuestionFragment } from './Question.graphql';

export const QuestionSectionFragment = gql`
  fragment QuestionSection on QuestionSection {
    id
    sectionCode
    displayText
    displaySubtext
    displayOrder
    questions {
      ...Question
    }
  }
  ${QuestionFragment}
`;
